import {referenceBookRulesRoutes} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/referenceBookRulesRoutes";
import {referenceBookListsRoutes} from "@/routes/ProtectedRoutes/ReferenceBooksRoutes/referenceBookListsRoutes";
import {Route} from "react-router-dom";
import {lazy} from "react";
import UrlsConfig from "@/config/UrlsConfig";

const ReferenceBooksShowcase = lazy(() => import("@/pages/ReferenceBooks/ReferenceBooksShowcase"));

export function referenceBooksRoutes() {
    const urlsConfig = new UrlsConfig();

    return (
      <>
          <Route path={urlsConfig.referenceBooksShowcase.to} element={<ReferenceBooksShowcase/>}/>
          {referenceBookListsRoutes()}
          {referenceBookRulesRoutes()}
      </>
    );
}
